import { api } from "@/lib/api";

export const PRAYER_ACCENT = "var(--yalola-secondary)";
export const PRAYER_ACCENT_SOFT = "var(--yalola-secondary-soft)";
export const PRAYER_REACTIONS = [
  { type: "heart", emoji: "❤️", tKey: null, fb: "" },
  { type: "amen", emoji: "🙌", tKey: "prayers.amen", fb: "Amen" },
];
export const QUICK_ENCOURAGEMENTS = [
  { key: "prayers.quick_1", fb: "Je prie pour toi 🙏" },
  { key: "prayers.quick_2", fb: "Courage, tu n'es pas seul(e) ❤️" },
  { key: "prayers.quick_3", fb: "Que la paix de Dieu garde ton cœur (Philippiens 4:7)" },
  { key: "prayers.quick_4", fb: "« Je suis avec toi » — Ésaïe 41:10" },
  { key: "prayers.quick_5", fb: "Amen, je m'unis à ta prière 🙌" },
  { key: "prayers.quick_6", fb: "Dieu entend ta prière ✨" },
];

export const fill = (s, vars) => Object.entries(vars).reduce((acc, [k, v]) => acc.split(`{${k}}`).join(String(v)), s || "");

// Character limits managed by the admin (Paramètres › Limites) — never the whole text in banners/widgets.
export const excerpt = (text, n) => {
  const s = (text || "").trim();
  if (!n || s.length <= n) return s;
  const cut = s.slice(0, n - 1);
  const sp = cut.lastIndexOf(" ");
  return (sp > n * 0.6 ? cut.slice(0, sp) : cut).trimEnd() + "…";
};
export const prayerExcerptChars = (config) => {
  const n = Number(config?.settings?.prayer_excerpt_chars);
  return n >= 60 && n <= 600 ? n : 220;
};
export const prayerMaxChars = (config) => {
  const n = Number(config?.settings?.prayer_max_chars);
  return n >= 100 && n <= 2000 ? n : 1000;
};

export const timeAgo = (iso, lang) => {
  try {
    const d = new Date(iso);
    const s = Math.floor((Date.now() - d.getTime()) / 1000);
    if (s < 60) return "à l'instant";
    if (s < 3600) return `${Math.floor(s / 60)} min`;
    if (s < 86400) return `${Math.floor(s / 3600)} h`;
    return d.toLocaleDateString(lang || "fr", { day: "numeric", month: "short" });
  } catch { return ""; }
};

export const togglePray = async (id) => (await api.post(`/prayers/${id}/pray`)).data;
export const toggleReact = async (id, type) => (await api.post(`/prayers/${id}/react`, { type })).data;

const meMini = (user) => ({ id: user.id, name: user.name, avatar_url: user.avatar_url, gender: user.gender, is_verified: user.is_verified, verified_type: user.verified_type, role: user.role });

// Local patch after « Je prie » : counter + intercessor preview stay in sync without a reload.
export const applyPray = (p, data, user) => {
  const others = (p.intercessors || []).filter((u) => u.id !== user?.id);
  const intercessors = data.prayed && user ? [meMini(user), ...others].slice(0, 3) : others;
  return { ...p, prayed_by_me: data.prayed, pray_count: data.pray_count, intercessors };
};

export const applyReact = (p, data) => {
  const mine = new Set(p.my_reactions || []);
  if (data.reacted) mine.add(data.type); else mine.delete(data.type);
  return { ...p, reactions: data.reactions, my_reactions: [...mine] };
};

const first = (n) => (n || "").trim().split(/\s+/)[0] || "…";

// « Marie, Paul et 5 autres prient » — the viewer is always shown first as « Toi ».
export const prayingLabel = (p, user, t) => {
  const total = Number(p.pray_count) || 0;
  if (!total) return t("prayers.be_first", "Sois le premier à prier 🙏");
  const list = [...(p.intercessors || [])].sort((a, b) => (b.id === user?.id) - (a.id === user?.id));
  const names = list.map((u) => (user && u.id === user.id ? t("prayers.praying_you", "Toi") : first(u.name)));
  if (total === 1) return fill(t("prayers.praying_one", "{name} prie"), { name: names[0] || "…" });
  if (total === 2 && names.length >= 2) return fill(t("prayers.praying_two", "{a} et {b} prient"), { a: names[0], b: names[1] });
  const shown = names.slice(0, 2);
  const rest = total - shown.length;
  if (rest <= 0) return fill(t("prayers.praying_two", "{a} et {b} prient"), { a: shown[0], b: shown[1] || "…" });
  return fill(t("prayers.praying_more", "{names} et {n} autre(s) prient"), { names: shown.join(", "), n: rest });
};

export const testimonyDraft = (p, t) => {
  const parts = [`${t("prayers.testimony_tpl_prayer", "🙏 Sujet de prière")}\n${(p.content || "").trim()}`];
  const note = (p.answered_note || "").trim();
  parts.push(note ? `${t("prayers.testimony_tpl_answer", "✨ Comment Dieu a répondu")}\n${note}` : t("prayers.testimony_tpl_generic", "Dieu a répondu à cette prière ✨"));
  return parts.join("\n\n");
};
